// extracted by css-extract-rspack-plugin
export default {"cls1":"ContentFeedback-cls1_YP9","cls2":"ContentFeedback-cls2_Fc5 ContentFeedback-cls1_YP9"};